
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.857.412l-4.831 5.33L2.136.466a1.176 1.176 0 00-1.767.01 1.45 1.45 0 00.01 1.927l5.786 6.241c.491.53 1.28.526 1.766-.01l5.715-6.305a1.45 1.45 0 00-.01-1.927c-.492-.517-1.294-.526-1.78.01z","fill":"#000"}})])
          )
        }
      }
    